import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DefaultButton, Text, MessageBar, MessageBarType, Panel, PanelType } from '@fluentui/react';
import { getClassNames } from './index.classNames';
import InternalUsers from './content/internal';
import ExternalUsers from './content/external';
import NewExternalUser from './content/functionalities/newExternalUser';
import ScrollablePane from '../../../components/scrollablePane/index';
import Notification from '../../notification/index';
import { MainCompGenerator as GenericModalGenerator } from '@pwbapps/genericdialog';
import { CommandActions } from '../../../redux/actions/administrationModal';
import { ModalCommandActions } from '../../../redux/actions/modal';
import { getOpenModal, getUsersBusy, getUsersError } from '../../../redux/reducers/administrationModal';
import { getCanManageUsers, getRolesLoading } from '../../../redux/reducers/initialization';
import { getDarkModeEnabled, getSelectedProjectId } from '../../../redux/reducers/project';
import { getStakeHolders } from '../../../redux/reducers/sharedData';
import { getNotification } from '../../../redux/selectors/notification';
import { isExternalApp } from '../../../utils/costants';

const GenericModal = GenericModalGenerator();

export default function ModalAdministration() {
    const dispatch = useDispatch();
    const open = useSelector(getOpenModal);
    const busy = useSelector(getUsersBusy);
    const error = useSelector(getUsersError);
    const canManage = useSelector(getCanManageUsers);
    const rolesLoading = useSelector(getRolesLoading);
    const projectId = useSelector(getSelectedProjectId);
    const stakeHolders = useSelector(getStakeHolders);
    const darkModeEnabled = useSelector(getDarkModeEnabled);
    const notification = useSelector((state: any) => getNotification('administration')(state));
    if (!open || isExternalApp) return null;
    const styles = getClassNames();
    const disabled = busy || rolesLoading || !canManage;
    return <>
        <Panel isOpen={open} hasCloseButton={false} type={PanelType.large} closeButtonAriaLabel="Close"
            styles={{navigation: styles.header, content: styles.content, scrollableContent: styles.scrollableContent, footer: styles.footer, contentInner: styles.contentInner}}
            onRenderNavigationContent={() => <div style={{display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12, width: '100%', marginLeft: 30, marginRight: 120}}>
                <Text variant="xLarge">Administration panel - {projectId}</Text>
                <div style={{display: 'flex', flexWrap: 'wrap', gap: 20}}>
                    <DefaultButton text="Export users" className={styles.button} disabled={disabled} onClick={() => dispatch(CommandActions.downloadUsers())} />
                    <DefaultButton text="New external user" className={styles.button} disabled={disabled || !stakeHolders.length}
                        title={!stakeHolders.length ? 'There are no stakeholders in this project. Please contact your IT support.' : ''}
                        onClick={() => dispatch(ModalCommandActions.openModal({id: 'newExternalUser', contextItem: {email: undefined, company: undefined, country: undefined, notifications: [], errors: undefined}}))} />
                </div>
            </div>}
            onRenderFooterContent={() => <div>
                <DefaultButton primary split text="Save" className={styles.button} disabled={disabled} onClick={() => dispatch(CommandActions.saveUsers())} />
                <DefaultButton text="Cancel" className={styles.button} disabled={busy} onClick={() => dispatch(CommandActions.resetAndCloseModal())} />
            </div>}>
            <div className={styles.notify}>
                {error && <MessageBar messageBarType={MessageBarType.error}>{error}</MessageBar>}
                <Notification name="administration" show={notification.show} type={notification.type} message={notification.message} permanent={notification.permanent} />
            </div>
            <ScrollablePane className={styles.notifyHeader} darkModeEnabled={darkModeEnabled} items={[
                {text: 'Internal users', body: <div className={styles.tabContainer}><InternalUsers canAuthorize={!disabled} /></div>},
                {text: 'External users', body: <div className={styles.tabContainer}><ExternalUsers canAuthorize={!disabled} /></div>}
            ]} />
        </Panel>
        <GenericModal id="newExternalUser" title="New external user" message=""
            onClose={() => dispatch(ModalCommandActions.closeModal({id: 'newExternalUser'}))}
            onConfirm={() => dispatch(CommandActions.saveNewExternalUser())}
            btnCloseText="Cancel" btnConfirmText="Save" disableConfirm={disabled} disableClose={busy}
            customComponent={<><NewExternalUser />{error && <MessageBar messageBarType={MessageBarType.error}>{error}</MessageBar>}</>}
            disableAutoModalClose showLoaderWhileDisabled width={640} />
    </>;
}